import { Component, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { take, takeUntil } from 'rxjs';
import { MemberPermissionSale } from '../../models/sales/membe-permission-sale.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { SalesFacade } from '../../shared-new/store/sales/sales.facade';
import { SaleMemberAccessDataSource } from './sale-member-access.datasource';

@Component({
  selector: 'app-sale-member-access-popup',
  templateUrl: './sale-member-access-popup.component.html',
  styleUrls: ['./sale-member-access-popup.component.scss']
})
export class SaleMemberAccessPopupComponent extends BaseUnsubscribeComponent implements OnInit {

  public dataSource: SaleMemberAccessDataSource;
  formGroup: FormGroup;
  displayedColumns: string[] = [
    'saleImageUrl',
    'saleName',
    'isViewAccess',
    'isSubmitAccess',
    //'isXrayDownloadAccess',
    //'isTemporaryAccess',
    //'isJoined'
  ];
 @Input() public data: any;
 @Input() public stickyTop = '8rem';
 @Input() public isOtherDialog: boolean = false;
  @ViewChild(MatSort) accsort: MatSort;
  constructor(private fb: FormBuilder, private salesFacade: SalesFacade,  @Optional() public readonly modal?: NgbActiveModal) {
      super();
    this.formGroup = this.fb.group({
      permissions: this.fb.array([])
    });
  }

  ngOnInit() {
    this.salesFacade.loadSaleMemberPermission(this.data?.memberId);
    this.attachEvents();
  }
  dismissPopup() {
    this.modal.dismiss('cancel form');
  }
  closePopup() {
    this.salesFacade.clearSaleMemberAccess();
    const model = {
      data: this.formGroup.value.permissions,
      memberId: this.data?.memberId
    }
    this.formGroup.reset();   // ✅ Reset form
    this.permissions.clear(); // ✅ Clear array completely
    this.modal.close(JSON.stringify(model));
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  get permissions(): FormArray {
    return this.formGroup.get('permissions') as FormArray;
  }

  // Fetch data from API
  attachEvents() {
    this.salesFacade.selectSaleMemberPermission$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      if (data.length > 0) {
        this.dataSource = new SaleMemberAccessDataSource(data, this.accsort);

        this.populateFormArray(data);
      } else {
        this.dataSource = new SaleMemberAccessDataSource([], this.accsort);
      }
    });
    this.salesFacade.selectUpdateSaleMemberAccess$.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      if (data) {
        this.closePopup();
      }
    });
  }

  setupFormWatchers(): void {
    const formArray = this.formGroup.get('permissions') as FormArray;

    formArray.controls.forEach((group: AbstractControl) => {
      const isSubmit = group.get('isSubmitAccess');
      const isView = group.get('isViewAccess');

     

      if (isSubmit?.value) {
        isView?.setValue(true, { emitEvent: false });
        isView?.disable({ emitEvent: false });
      } else {
        isView?.enable({ emitEvent: false });
      }

      isSubmit?.valueChanges.subscribe((submitChecked: boolean) => {
        if (submitChecked) {
          isView?.setValue(true);
          isView?.disable({ emitEvent: false });
        } else {
          isView?.enable({ emitEvent: false });
        }
      });
    });
  }


  // Populate the FormArray with controls
  populateFormArray(data: MemberPermissionSale[]) {
    const formArray = this.permissions;
    formArray.clear();
    data.forEach(item => {
      formArray.push(this.fb.group({
        saleImageUrl: [item.saleImageUrl],
        saleName: [item.saleName],
        location: [item.location],
        startDate: [item.startDate],
        isViewAccess: [item.isViewAccess],
        isSubmitAccess: [item.isSubmitAccess],
        //isXrayDownloadAccess: [item.isXrayDownloadAccess],
        //isTemporaryAccess: [item.isTemporaryAccess],
        //isJoined: [item.isJoined],
        saleMemberAccessId: [item.saleMemberAccessId],
        saleId: [item.saleId],
        salesCompanyId: [item.salesCompanyId],
        memberId: [item.memberId],
      }));
    });

    this.setupFormWatchers();
  }

  getControl(index: number, field: string) {
    return this.permissions.at(index).get(field);
  }

  getFormData() {
    const saleMemberAccess: MemberPermissionSale[] = this.formGroup.getRawValue().permissions as MemberPermissionSale[];
    return saleMemberAccess;
  }

  save() {
    if (this.formGroup.valid) {
      const saleMemberAccess: MemberPermissionSale[] = this.formGroup.getRawValue().permissions as MemberPermissionSale[];
      this.salesFacade.updateSaleMemberAccess(saleMemberAccess);
     
    }
  }

}
